import { SxProps } from '@mui/material'
import { Theme } from '@mui/system'

export function makeSx<T extends { [key: string]: SxProps<Theme> }>(arg: T): T {
    return arg
}

export const mergeSx = (sxs: Array<SxProps | SxProps<Theme> | undefined>): SxProps => {
    const validStyles = sxs.filter((sx): sx is SxProps => sx !== undefined)
    return Object.assign({}, ...validStyles)
}

export const msxs = (...sxs: Array<SxProps | SxProps<Theme> | undefined>): SxProps => {
    const validStyles = sxs.filter((sx): sx is SxProps => sx !== undefined)
    return Object.assign({}, ...validStyles)
}
